import * as service from './compliance.service'
//FG - FOOF - 12-11-2018 - I added the class below. 
//     It is used locally (as in a "work" variable) to keep
//     track of the "uploaded" files.
class ComplianceDocumentUploadFileHelper  {
  helperListIndex=0                 //filled in by code in this file
  ComplianceDocumentId=0            //corresponds to the Id value downloaded from the server for existing (i.e. already uploaded) files
  ComplianceDocumentPath=''         //corresponds to the DocumentPath value downloaded from the server for existing (i.e. already uploaded) files
  ComplianceDocumentRealFileName='' //corresponds to the RealFileName value downloaded from the server for existing (i.e. already uploaded) files
  actualFile=''                     //filled in when a user chooses a file to uploaded (file content)
  action=0                          //action to take for the file (0-do nothing, 1-delete, 2-add)
  static ACTION_DO_NOTHING = 0;
  static ACTION_DELETE     = 1;
  static ACTION_ADD        = 2;
}
export default {
  data() {
    /********************************************************************************************
     * FG - FOOF - 12-4-2018 - 
     *  Columns were:
     *    compliance_columns: ['Number', 'Title', 'Revision', 'AttachedFiles', 'Actions'],
     *  I changed them to:
     *    compliance_columns: ['Title', 'CreatedOn', 'RevisedOn','ApprovedOn', 'AttachedFiles', 'Actions'],
     *******************************************************************************************/
    return {
      compliance_columns: ['Title', 'CreatedOn', 'RevisedOn','ApprovedOn', 'AttachedFiles', 'Actions'],
      attachmentcolor: 'gray',
      optionstable: {
        skin: this.$hydrowareCommonJS.hydrowareTableSkin,
        headings: {
          AttachedFiles: 'Attached Files',
          CreatedOn: 'Created On',
          RevisedOn: 'Revised On',
          ApprovedOn:'Approved On',
          Actions: ''
        },

        columnsClasses: {
          //"Title":"hydroware-title-column",
          "Actions":"hydroware-2-button-column",
          "CreatedOn":"hidden-xs hydroware-date-column",
          "RevisedOn":"hidden-xs hydroware-date-column",
          "ApprovedOn":"hidden-xs hydroware-date-column",
          "AttachedFiles":"hidden-xs hidden-sm"
        },
        perPage: 5,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: ["Title", "CreatedOn","RevisedOn", "ApprovedOn"],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },
      //FG - FOOF - 12-211-2018 - the name "addDocument" was in place before I got the code
      //     it is not necassarily a document that is being added and at some point in the
      //     future I may change the name.
      addDocument: {
        Instructions: '',
        Title: '',
        Number: '',
        Revision: '',
        CreatedBy: '',
        CreatedOn: '',
        RevisedBy: '',
        RevisedOn: '',
        ApprovedBy: '',
        ApprovedOn: '',
        Notes: '',
        Attachments: [],
        ForAllLocations: ''
      },
      rules: {
        Title: [
          {required: true, message: 'This field is required'},
          {min: 1, max: 50, message: 'Length should be 1 to 50'}
        ],
        //FG - FOOF - After Cert - First Release - (2) 
        //  - For first release, at least, Number is NOT required
        //  - ALSO - this value is specified as nvarchar(5) in the DB so it does not HAVE TO BE A number either
        Number: [
          //{required: false, message: 'This field is required'},
          //{type: 'number', message: 'value must be a number'}
        ],
        //FG - FOOF - After Cert - First Release - (2) 
        //  - For first release, at least, Revision is NOT required
        //  - ALSO - this value is specified as nvarchar(5) in the DB so it does not HAVE TO BE A number either
        Revision: [
          //{required: true,message: 'This field is required'},
          //{type: 'number', message: 'value must be a number'},
        ],
      },
      labelPosition: 'top',
      Documents: [],
      Users: [],
      image_data: [],   //FG - FOOF - this becomes a FormData instance and is passed to the server
      attachedfiles: [],  
      //FG - FOOF - Dec 11 2018 - added variable below
      //  It holds onto one ComplianceDocumentUploadFileHelper instance for each file that either has been or will be uploaded
      uploadFileHelperArray: [], 
      Attachments: [], //FG - FOOF - this array will the files to be uploaded to the server 
      //FG - FOOF - DEC 11 2018 - I'd like to change things so the var below lists the id's of the files to be deleted
      DocIds: [],      //FG - FOOF - this array will become a delimited string of the ids that should be kept
      locationName: '',
      modalTitle: '',
      locationId: 25,
      isediting: false,
      isaddding: false,
      isAddingOrEditing:"" //FG - FOOF - After Cert - First Release Security (7)
    }
  },
  mounted() {
    
    let context = this
    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.locationId = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if (context.locationId) {
        context.GetAllComplianceDocs(context.locationId) 
      }
    })
    this.image_data=[]
    this.image_data = new FormData()
    this.GetAllUsers()
  },

  //FG - FOOF - TOOLTIPSTER REINITIALIZE ON RESIZE
  created() {
    this.$hydrowareCommonJS.handleTooltips("create");
  },

  destroyed() {
    this.$hydrowareCommonJS.handleTooltips("destroy");
  },

  methods: {
    
    addCompliancevit() {
      this.isaddding = true
      this.isAddingOrEditing="A"; //FG - FOOF - After Cert - First Release Security (7)
      
      this.uploadFileHelperArray = [] //FG - Dec 11 2018 - initialize the array that is used to keep track of the upload files
      
      this.addDocument = {
        Instructions: '',
        Title: '',
        Number: '',
        Revision: '',
        CreatedBy: '',
        CreatedOn: '',
        RevisedBy: '',
        RevisedOn: '',
        ApprovedBy: '',
        ApprovedOn: '',
        Notes: '',
        Attachments: [],
        ForAllLocations: false
      }
      this.Attachments = [] //FG - FOOF - is this necassary ?
      this.addDocument.RevisedBy = this.Users[0].Id
      this.addDocument.CreatedBy = this.Users[0].Id
      this.addDocument.ApprovedBy = this.Users[0].Id
    },
    setAttachment(e) {
      let context = this
      function getExtension(filename) {
        var parts = filename.split('.')
        return parts[parts.length - 1]
      }
      for (var i = 0; i < e.target.files.length; i++) {
        var name = e.target.files[i].name
        var type = e.target.files[i].type
        var size = e.target.files[i].size
        //FG - FOOF - needs to add the xlsx and xls extentions
        if ( type != 'image/jpeg' 
          && type != 'image/jpg' 
          && type != 'image/png' 
          && getExtension(name) != 'xlsx' //FG - FOOF - Dec 12 2018
          && getExtension(name) != 'xls'  //FG - FOOF - Dec 12 2018
          && getExtension(name) != 'docx' 
          && getExtension(name) != 'doc' 
          && getExtension(name) != 'txt' 
          && getExtension(name) != 'pdf') {
          alert('Invalid file format')
          return
        }
        if (size == 0) {
          alert('File is Empty')
          return
        }
        if (size > 5000000) {
          alert('You have exceeded the maximum image size of 5 MB')
          return
        }
        //FG - FOOF - DEC 11 2018 - push the new file into the uploadFileHelperArray
        var newFile = new ComplianceDocumentUploadFileHelper();
        newFile.helperListIndex=this.uploadFileHelperArray.length                 
        newFile.ComplianceDocumentId=-1           
        newFile.ComplianceDocumentPath=''      
        newFile.ComplianceDocumentRealFileName=name
        newFile.actualFile=e.target.files[i]                  
        newFile.action=ComplianceDocumentUploadFileHelper.ACTION_ADD       
        this.uploadFileHelperArray.push(newFile)
      }
    },
    removeAttachedFile(tag) {
      //FG - FOOF - After Cert - First Release (6) - added confirm for removing uploaded files
      //PRIOR MODS
      //   FG - FOOF - Dec 11 2018 - Mark the file for deletion
      //   NOTE: this will set the value of action for the entry in the
      //         uploadFileHelperArray that corresponds to the file
      //         whose "x" was clicked.
      let context = this
      var opts = {title:"Remove file", 
        message: 'Are you sure you want to delete file ' + tag.ComplianceDocumentRealFileName + ' from this document?'
                 + '<BR><BR>NOTE: This action will not be completed until you add (or update) the document.'
      }
      context.$hydrowareCommonJS.displayConfirmDeletePopup(this, opts, this.tagDocumentForDelete.bind(null,tag))
      //tag.action=ComplianceDocumentUploadFileHelper.ACTION_DELETE;
    },
    tagDocumentForDelete(tag) {
      //alert("TAGGING")
      tag.action=ComplianceDocumentUploadFileHelper.ACTION_DELETE;
    },
    showCompliancevit() {
      this.isaddding = false     
      this.isediting = false
      this.isAddingOrEditing=""; //FG - FOOF - After Cert - First Release Security (7)
    },
    GetAllComplianceDocs(locationId) {
      let context = this
      loader.startLoader()
      service.GetAllComplianceDocs(locationId).then(function (response) {
      //FG - FOOF - After Cert - First Release Security (7) Can the user at least view the data ?
      if(context.$hydrowareSecurityJS.isDataRestricted(response)) {
        context.Documents = []
        loader.stopLoader();
        return;
      }
      //FG - FOOF - After Cert - First Release Security (7) - above

        if (response && response != null) {
          context.Documents = response
          tooltip.startTooltip(50)
        } else {
          context.Documents = []
        }
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetAllUsers() {
      let context = this
      loader.startLoader()
      service.GetAllUsers().then(function (response) {
        if (response && response != null) {
          context.Users = response
        } else {
          context.Users = []
        }
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    del: function (data) {
      var ID = data.row.Id
      let context = this
      var opts = {message: 'Are you sure you want to delete document ' + data.row.Title +'?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteAComplianceDocument.bind(null,ID))
    },
    deleteAComplianceDocument(ID) {
      var context=this;
      loader.startLoader()
      service.DeleteComplianceDoc(ID).then(function (response) {

        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
          return;

        context.GetAllComplianceDocs(context.locationId)
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
      }, (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },
    //FG - FOOF - After Cert - First Release (6) - rewrote delete code above to use new methods in hydrowareCommonJS.js
    
    
    cancelpopup: function () {
      $('#Addkudosmodel').modal('hide')
    },


    editcol: function (data) {
      this.uploadFileHelperArray = [] //FG - Dec 11 2018 - initialize the array that is used to keep track of the upload files
      this.Attachments = []
      this.DocIds = [] //FG - FOOF - Dec 8 2018 - added this because docs were sometimes left behind
      var ID = data.row.Id
      let context = this
      context.EditableColID = ID
      context.addDocument               = data.row
      context.addDocument['Id']         = ID
      context.addDocument['CreatedBy']  = data.row.CreatedUserId
      context.addDocument['RevisedBy']  = data.row.RevisedUserId
      context.addDocument['ApprovedBy'] = data.row.ApprovedUserId
      if (data.row.CreatedOn)  {context.addDocument["CreatedOn"]  = new Date(data.row.CreatedOn)}
      if (data.row.RevisedOn)  {context.addDocument["RevisedOn"]  = new Date(data.row.RevisedOn)}
      if (data.row.ApprovedOn) {context.addDocument["ApprovedOn"] = new Date(data.row.ApprovedOn)}
      //FG - FOOF - After Cert - First Release (2) - The database has the columns for number and revision
      //   defined as nvarchar(50) thus they DO NOT NEED TO BE NUMBERS... parsing them causes
      //   "NaN" to be displayed so they should not be parsed.
        //if (data.row.Number)     {context.addDocument["Number"]     = parseInt(data.row.Number)}
        //if (data.row.Revision)   {context.addDocument["Revision"]   = parseInt(data.row.Revision)}
        context.addDocument["Number"]     = data.row.Number
        context.addDocument["Revision"]     = data.row.Revision

      context.addDocument.ComplianceDocumentFiles = context.addDocument.ComplianceDocumentFiles ? context.addDocument.ComplianceDocumentFiles : []
      //FG - FOOF - 12-11-2018 - added comment
      //    ComplianceDocumentFiles hold onto the list of files that have already been
      //    uploaded for a Compliance Document.  It is the list of files that is
      //    delivered FROM the server to the client when editting a row.
      //    The pertinent info for each entry in the list is:
      //        Id (aka DocId) - the id for the DB row storing the uploaded doc
      //        DocumentPath - the path to find the uploaded doc in the file system (including filename)
      //        RealFileName - the name of the file as stored in the file system (same as the filename in the path)
      //
      //FG - FOOF - 12-11-2018 - I changed the way we process uploaded files.
      //     I use the uploadFileHelper and uploadFileHelperArray to hold onto all the
      //     info I need to process the uploaded and to be uploaded files.
      //     When the user "submits" this page I go thru the uploadFileHelperArray
      //     to create the info the server needs to process the files properly.
      for (var i = 0; i < context.addDocument.ComplianceDocumentFiles.length; i++) {
        var uploadFileHelper                    = new ComplianceDocumentUploadFileHelper ()
        uploadFileHelper.helperListIndex        = i
        uploadFileHelper.ComplianceDocumentId   =context.addDocument.ComplianceDocumentFiles[i].Id,            
        uploadFileHelper.ComplianceDocumentPath =context.addDocument.ComplianceDocumentFiles[i].DocumentPath,        
        uploadFileHelper.ComplianceDocumentRealFileName=context.addDocument.ComplianceDocumentFiles[i].RealFileName, 
        uploadFileHelper.actualFile             =null,                     
        uploadFileHelper.action                 =ComplianceDocumentUploadFileHelper.ACTION_DO_NOTHING
        context.uploadFileHelperArray.push(uploadFileHelper);
      }
      context.isediting = true
      context.isAddingOrEditing=context.$hydrowareSecurityJS.showViewOrEditOrNeitherButton_A('compliancedoc');
      //context.isAddingOrEditing="E"; //FG - FOOF - After Cert - First Release Security (7)

    }, //FG - END OF editcol

    //FG - DEC 12-2018 CONDENSED THIS CODE WHEN I RE-WROTE THE WAY UPLOADS WORK
    AddComplianceDocument(formName) {
      return this.AddOrUpdateComplianceDocument(formName);
    },
    //FG - DEC 12-2018 CONDENSED THIS CODE WHEN I RE-WROTE THE WAY UPLOADS WORK
    UpdateComplianceDocument(formName) {
      return this.AddOrUpdateComplianceDocument(formName,true);
    },
    //FG - DEC 12-2018 One of the methods for the condensed code I wrote for update and add
    AddOrUpdateComplianceDocument(formName, isUpdate=false) {
      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loader.startLoader()
          this.setupDataThatWillBeSentToServer(true); //FG - FOOF - Dec 12-2018 - "true" indicates update
          service.AddOrUpdateComplianceDocument(this.image_data,isUpdate).then(function (response) {
            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{}))
              return;

            loader.stopLoader()
            context.$notify({
              title: 'Success',
              message: isUpdate ?  'Compliance Document  Details Updated' : 'Compliance Document Detail  Created',
              //message: 'Compliance Document  Details Updated',
              type: 'success'
            })
            context.GetAllComplianceDocs(context.locationId)
            context.isediting = false
            context.isaddding = false
            this.isAddingOrEditing=""; //FG - FOOF - After Cert - First Release Security (7)
          }, (error) => {
            loader.stopLoader()
            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } 
        else {
          this.$notify({
            title: 'Error',
            message: 'compliance_doc.controller AddOrUpdate error on submit!!',
            type: 'error'
          })
          return false
        }
      })
    },
    //FG - FOOF - Dec 12 2018 - function below eliminated duplicate code from Digiclarity and
    //    is another method I wrote to condense code
    setupDataThatWillBeSentToServer(isUpdate) {
        let context = this
            var image_arr = {}
            this.image_data = new FormData() //FG - FOOF - added on Dec 12 2018 while testing for uploads
            if(isUpdate) {
              if (context.addDocument.Id) {
                image_arr['Id'] = context.addDocument.Id
              }
            }
            if (context.locationId) {
              image_arr['LocationId'] = context.locationId
            }
            if (context.addDocument.Instructions) {
              image_arr['Instructions'] = context.addDocument.Instructions
            } else {
              image_arr['Instructions'] = ''
            }
            if (context.addDocument.Title) {
              image_arr['Title'] = context.addDocument.Title
            } else {
              image_arr['Title'] = ''
            }
            if (context.addDocument.Number) {
              image_arr['Number'] = context.addDocument.Number
            } else {
              image_arr['Number'] = ''
            }
            if (context.addDocument.Revision) {
              image_arr['Revision'] = context.addDocument.Revision
            } else {
              image_arr['Revision'] = ''
            }
            if (context.addDocument.CreatedBy) {
              image_arr['CreatedBy'] = context.addDocument.CreatedBy
            } else {
              image_arr['CreatedBy'] = ''
            }
            if (context.addDocument.CreatedOn) {
              image_arr['CreatedOn'] = context.$options.filters.fdate(context.addDocument.CreatedOn)
            } else {
              image_arr['CreatedOn'] = ''
            }
            if (context.addDocument.RevisedBy) {
              image_arr['RevisedBy'] = context.addDocument.RevisedBy
            } else {
              image_arr['RevisedBy'] = ''
            }
            if (context.addDocument.RevisedOn) {
              image_arr['RevisedOn'] = context.$options.filters.fdate(context.addDocument.RevisedOn)
            } else {
              image_arr['RevisedOn'] = ''
            }
            if (context.addDocument.ApprovedBy) {
              image_arr['ApprovedBy'] = context.addDocument.ApprovedBy
            } else {
              image_arr['ApprovedBy'] = ''
            }
            if (context.addDocument.ApprovedOn) {
              image_arr['ApprovedOn'] = context.$options.filters.fdate(context.addDocument.ApprovedOn)
            } else {
              image_arr['ApprovedOn'] = ''
            }
            if (context.addDocument.Notes) {
              image_arr['Notes'] = context.addDocument.Notes
            } else {
              image_arr['Notes'] = ''
            }
            if (context.addDocument.ForAllLocations) {
              image_arr['ForAllLocations'] = context.addDocument.ForAllLocations
            } else {
              image_arr['ForAllLocations'] = ''
            }
            for (var key in image_arr) {
              this.image_data.append(key, image_arr[key])
            }
            //FG - FOOF - Dec 11 2018 - make sure the new files are uploaded (Attachements)
            //   AND the id's of the files to keep DocIds are also uploaded
            //   NOTE: THIS SEEMS BACKWARD TO ME... I'D LIKE THIS TO BE THE ID's OF DOCS TO BE DELETED
            context.DocIds="0";
            var attachmentsIdx=0;
            for(var foofidx=0; foofidx<this.uploadFileHelperArray.length; foofidx++) {
              var aFileHelper = this.uploadFileHelperArray[foofidx];
              if(aFileHelper.action==ComplianceDocumentUploadFileHelper.ACTION_ADD) {
                this.image_data.append('Attachments[' + attachmentsIdx + ']', aFileHelper.actualFile)
                attachmentsIdx++
              }
              else {
                if(aFileHelper.action==ComplianceDocumentUploadFileHelper.ACTION_DO_NOTHING) {
                  if(context.DocIds == "0")
                    context.DocIds = aFileHelper.ComplianceDocumentId
                  else {
                    context.DocIds += ',' //comma is only need if there is more than one doc id to list
                    context.DocIds += aFileHelper.ComplianceDocumentId
                  }
                }
              }
            }
            this.image_data.append("DocIds",context.DocIds);
            return this.image_data
    },



    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {
    "addDocument.Instructions": function (val) {

      $('.trumbowyg-editor').find('a').each(function () {
        var x = $(this).text()
        var p = " " + x + " "
        $(this).text(p)
      })



      $('.trumbowyg-editor').find('a').click(function () {


        window.open($(this).prop('href'), '_blank');

      })
    },
    isediting: function (val) {
      this.$router.app.$emit('sidebar_hide', val)
    },
    isaddding: function (val) {

      this.$router.app.$emit('sidebar_hide', val)
    }


  },
}



// WEBPACK FOOTER //
// ./src/pages/Compliance/compliance_doc.controller.js